import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";
import { fetchResourcesStoreInfo } from "./api/resourcesStoreApi";
import { IResourcesStoreInfo } from "./types";

export const getResourcesStoreInfo = createAsyncThunk<
  IResourcesStoreInfo | undefined,
  void,
  { state: RootState }
>(
  "resources/getResourcesStoreInfo",
  async () => {
    const result = await fetchResourcesStoreInfo();
    return result;
  },
  {
    condition: (_, { getState }) => {
      //avoid multiple concurrent fetchs
      const { resourcesStore } = getState();
      return !resourcesStore.loading;
    },
  }
);

type ResourcesStoreState = {
  resourcesStoreInfo?: IResourcesStoreInfo;
  loading: boolean;
  error?: string;
};
const initialState: ResourcesStoreState = {
  loading: false,
};
const resourcesStoreSlice = createSlice({
  name: "resourcesStore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getResourcesStoreInfo.pending, (state) => {
        if (!state.loading) {
          state.error = undefined;
          state.loading = true;
        }
      })
      .addCase(getResourcesStoreInfo.fulfilled, (state, action) => {
        const data = action.payload;
        state.loading = false;
        state.resourcesStoreInfo = data;
      })
      .addCase(getResourcesStoreInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.resourcesStoreInfo = undefined;
      });
  },
});

export default resourcesStoreSlice.reducer;
